import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-processing-dialog',
  templateUrl: './processing-dialog.component.html',
  styleUrls: ['./processing-dialog.component.scss']
})
export class ProcessingDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
